"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryNav = PrimaryNav;
exports.PrimaryNavContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _logo = _interopRequireDefault(require("./logo.js"));
var _index = require("./primary-nav-tray/index.js");
var _cart = require("./cart.js");
var _index2 = require("./account-tray/index.js");
var _notifications = _interopRequireDefault(require("@site/notifications"));
var _rightAlignedItem = require("./right-aligned-item.js");
var _index3 = require("./contact-us-tray/index.js");
var _helpCenterTray = require("./help-center-tray.js");
var _skipNavigation = require("./skip-navigation.js");
var _index4 = _interopRequireDefault(require("./site-search/index.js"));
var _pageHeader = require("../../page-header.js");
var _primaryNavContext = require("./primary-nav-context.js");
var _core = require("@linaria/core");
var _useSticky = require("../other/sticky-stack/use-sticky.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */
/* eslint-disable max-len */

const PrimaryNavContainer = exports.PrimaryNavContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PrimaryNavContainer",
  class: "pl-p15h58fl"
});
const LeftAlignedContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LeftAlignedContainer",
  class: "pl-l16jx60o"
});
const RightAlignedContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RightAlignedContainer",
  class: "pl-r1u0hp1j"
});

/**
 * Primary Nav
 * @module PrimaryNav
 * @param {Object} props React props
 * @param {Object} props.notificationTray Notification Tray
 * @param {Object} props.logo Logo
 * @param {Object} props.cartLink Cart link
 * @param {Object} props.accountTray Account Tray
 * @param {Object} props.primaryNav Primary Nav menu
 * @param {Object} props.contactUsTray Contact Us
 * @param {Object} props.siteSearch Site Search
 * @param {Object} props.themeSwitcher Theme Switcher
 * @param {Object} props.skipNavigation Skip Navigation
 * @param {Object} props.helpCenterTray Help Center Tray
 * @param {Array} props.rightAlignedLinks Right aligned links
 * @param {Sring} props._name Name for tracking
 * @param {String} props.guiHost Name for tracking
 * @param {Boolean} props.invert Dark Nav Trigger
 * @param {String} props.partial Theme partial
 * @param {String} props.privateLabelName Private Label Name
 * @param {Number} props.privateLabelId Private Label ID
 * @param {Boolean} props.isSticky Is the nav sticky
 * @param {Object} props.themeSwitcher Theme Switcher
 * @returns {React.ReactElement} React HTML element
 * @public
 */
function PrimaryNav({
  logo,
  cartLink,
  accountTray,
  primaryNav: primaryNavTray,
  siteSearch,
  themeSwitcher,
  contactUsTray,
  helpCenterTray,
  rightAlignedLinks = [],
  _name,
  guiHost,
  skipNavigation,
  invert = false,
  partial,
  isSticky = false,
  privateLabelName = 'GoDaddy',
  privateLabelId = 1
}) {
  const [customerRes, setCustomerRes] = (0, _react.useState)(null);
  const [infoResponse, setInfoResponse] = (0, _react.useState)(null);
  const [isLoggedIn, setIsLoggedIn] = (0, _react.useState)(false);
  const containerRef = (0, _react.useRef)(null);
  const {
    isStickyState
  } = (0, _useSticky.useSticky)('primary-nav', containerRef, isSticky);
  function handleResponse(response, info) {
    setCustomerRes(response);
    setInfoResponse(info);
    response?.info && setIsLoggedIn(true);
  }
  (0, _react.useEffect)(() => {
    try {
      let idpCookie = document.cookie.match('(^|;) ?info_idp=([^;]*)(;|$)');
      if (!idpCookie) {
        idpCookie = document.cookie.match('(^|;) ?info_cust_idp=([^;]*)(;|$)');
      }
      const idpCookieValue = idpCookie ? idpCookie[2] : null;
      if (idpCookieValue) {
        const cookieObj = window.decodeURIComponent && window.JSON && window.JSON.parse ? window.JSON.parse(window.decodeURIComponent(idpCookieValue)) : null;
        const sid = cookieObj.del ? cookieObj[cookieObj.auth].info_shopperId : cookieObj.info_shopperId;
        fetch(`${guiHost}/pcjson/salesheader?plId=${privateLabelId}&shopperId=${sid}&sid=${sid}`, {
          credentials: 'include'
        }).then(res => res.json()).then(res => {
          handleResponse(res, cookieObj);
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('An error occurred parsing info cookies', error);
    }
  }, [guiHost, privateLabelId]);
  const className = (0, _core.cx)('text', isStickyState && 'sticky');
  _patternLibraryUtils.tracking.useTracking(containerRef);
  const trackingProps = _patternLibraryUtils.tracking.props(_name, false, true);
  return /*#__PURE__*/_react.default.createElement(_primaryNavContext.PrimaryNavContext.Provider, {
    value: {
      privateLabelId,
      privateLabelName,
      isLoggedIn
    }
  }, /*#__PURE__*/_react.default.createElement(PrimaryNavContainer, (0, _extends2.default)({
    id: "primary-nav",
    ref: containerRef,
    "data-cy": "primary-nav",
    "data-partial": partial || (invert ? 'dark1' : ''),
    className: className
  }, trackingProps), /*#__PURE__*/_react.default.createElement(LeftAlignedContainer, null, skipNavigation ? /*#__PURE__*/_react.default.createElement(_skipNavigation.SkipNavigation, skipNavigation) : null, /*#__PURE__*/_react.default.createElement(_logo.default, (0, _extends2.default)({}, logo, {
    className: "nav-logo",
    "data-cy": "nav-logo"
  })), primaryNavTray ? /*#__PURE__*/_react.default.createElement(_index.PrimaryNavTray, (0, _extends2.default)({
    invert: invert,
    logo: logo
  }, primaryNavTray)) : null), /*#__PURE__*/_react.default.createElement(RightAlignedContainer, {
    invert: invert,
    "data-cy": "right-align-nav"
  }, siteSearch ? /*#__PURE__*/_react.default.createElement(_index4.default, siteSearch) : null, contactUsTray ? /*#__PURE__*/_react.default.createElement(_index3.ContactUsTray, (0, _extends2.default)({
    invert: invert
  }, contactUsTray)) : null, rightAlignedLinks?.length > 0 ? rightAlignedLinks.map(({
    href,
    title,
    icon,
    _name: linkName,
    id,
    ariaLabel
  }, i) => {
    return /*#__PURE__*/_react.default.createElement(_rightAlignedItem.RightAlignedItem, {
      key: i,
      id: id,
      href: href,
      title: title,
      icon: icon,
      _name: linkName,
      ariaLabel: ariaLabel,
      invert: invert
    });
  }) : null, helpCenterTray ? /*#__PURE__*/_react.default.createElement(_helpCenterTray.HelpCenterTray, helpCenterTray) : null, /*#__PURE__*/_react.default.createElement(_notifications.default, {
    appKey: "FOS",
    id: "notification-tray",
    manifest: "SalesHeader",
    "data-cy": "notification-tray"
  }), accountTray ? /*#__PURE__*/_react.default.createElement(_index2.AccountTray, (0, _extends2.default)({}, accountTray, {
    invert: invert,
    customerRes: customerRes,
    infoResponse: infoResponse
  })) : null, cartLink ? /*#__PURE__*/_react.default.createElement(_cart.Cart, (0, _extends2.default)({}, cartLink, {
    invert: invert,
    isEmpty: !(customerRes && customerRes.carttotal > 0),
    cartTotal: customerRes?.carttotal
  })) : null, themeSwitcher ? /*#__PURE__*/_react.default.createElement(_pageHeader.ThemeSwitcher, themeSwitcher) : null)));
}
PrimaryNav.propTypes = {
  notificationTray: _propTypes.default.object,
  logo: _propTypes.default.object.isRequired,
  cartLink: _propTypes.default.object.isRequired,
  accountTray: _propTypes.default.object,
  primaryNav: _propTypes.default.object.isRequired,
  siteSearch: _propTypes.default.object,
  themeSwitcher: _propTypes.default.object,
  skipNavigation: _propTypes.default.object,
  rightAlignedLinks: _propTypes.default.array,
  contactUsTray: _propTypes.default.object,
  helpCenterTray: _propTypes.default.object,
  isSticky: _propTypes.default.bool,
  _name: _propTypes.default.string,
  guiHost: _propTypes.default.string,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  privateLabelId: _propTypes.default.number,
  privateLabelName: _propTypes.default.string
};